// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ulc3","tabsBox":"styles_tabsBox__2clp8","createButton":"styles_createButton__NL3Zg"};